import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class MediaMessageProxyService {
  constructor(private http: HttpClient) {}

  save(messageRequest): Observable<boolean> {
    return this.http.post<boolean>('api/Stamp/AddMediaMessage', messageRequest);
  }

  createText(messageRequest): Observable<boolean> {
    return this.http.post<boolean>('api/Stamp/AddMediaMessage', messageRequest);
  }
}
